import "./App.css";
import { useState, useEffect } from "react";
import { TbMailFilled } from "react-icons/tb";
import { MdDownloadForOffline } from "react-icons/md";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";



export default function App() {


    // Dimensioni
    const [windowWidth, setWindowWidth]   = useState(window.innerWidth);
    const updateDimensions = () => {
        setWindowWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);


    // Timer
    const [timeString, setTimeString] = useState();
    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const missingHours = 23 - now.getHours();
            const missingMinutes = 60 - now.getMinutes();
            const missingSeconds = 60 - now.getSeconds();
            setTimeString(`- ${missingHours.toString().padStart(2, "0")} : ${missingMinutes.toString().padStart(2, "0")} : ${missingSeconds.toString().padStart(2, "0")}`)
        }, 200)
        return () => clearInterval(interval);
    }, [])


    // Contact us
    const [page, setPage] = useState("home");
    function home() {
        setPage("home");
    }
    function contactUs() {
        setPage("contactUs");
    }
    function download() {
        setPage("download");
    }

    


    return (

        <>
    
        <Analytics/>
        <SpeedInsights/>

        <div id="container">

            {

                windowWidth > 1300 ?

                <>

                <div id="header">
                    <div className={page!=="contactUs" ? "button" : "buttonActive"} onClick={contactUs}>
                        <TbMailFilled size={22} className="iconLight"/>
                        <p>Contact us</p>
                    </div>
                    <img src={require("./assets/logo.png")} id="logo" onClick={home} alt="Logo"/>
                    <div className={page!=="download" ? "button": "buttonActive"} onClick={download}>
                        <p>Download</p>
                        <MdDownloadForOffline size={22} className="iconLight"/>
                    </div>
                </div>

                <div id="main">
                    <div id="mainLeft">
                        <p>Turn your life</p>
                        <p>into a story.</p>
                    </div>
                    {
                        page === "home" ?
                        <div id="timer">
                            <p>{timeString}</p>
                        </div> :
                        page === "contactUs" ?
                        <div className="card">
                            <div className="cardHeader">
                                <TbMailFilled size={22} className="iconDark"/>
                                <p className="cardTitle">Contact us</p>
                            </div>
                            <p>Feel free to contact us for either any marketing propose or technical issue.</p>
                            <p id="cardMail">contact.mylife@gpdev.me</p>
                        </div> :
                        <div className="card">
                            <div className="cardHeader">
                                <MdDownloadForOffline size={22} className="iconDark"/>
                                <p className="cardTitle">Download</p>
                            </div>
                            <p>You can download MyL!fe app on Google Play Store. We're working to make it available on App Store, soon.</p>
                            <div className="cardStoreContainer">
                                <a className="cardStore" href="https://play.google.com/store/apps?hl=it&pli=1" target="_blank">
                                    <img src={require("./assets/playStore.png")} className="storeLogo"/>
                                    <p>Play Store</p>
                                </a>
                                <a className="cardStore" href="https://www.apple.com/it/app-store/" target="_blank">
                                    <img src={require("./assets/appStore.png")} className="storeLogo"/>
                                    <p>App Store</p>
                                </a>
                            </div>
                        </div>
                    }
                </div>

                {
                    page === "home" &&
                    <div id="footer">
                        <p>MyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe</p>
                        <p>!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe</p>
                        <p>MyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe</p>
                        <p>!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe</p>
                        <p>MyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe</p>
                        <p>!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe</p>
                    </div>
                }

                </>

                :

                <>
                
                    <div id="mobileHeader">
                        <img src={require("./assets/logo.png")} id="mobileLogo" onClick={home}/>
                    </div>

                    <div id="mobileMain">
                        <div id="mobileMainTop">
                            <p>Turn your life</p>
                            <p>into a story.</p>
                            <div id="mobileTimer">
                                <p>{timeString}</p>
                            </div>
                        </div>
                        <div id="mobileMainBottom">
                            {
                                page === "home" ?
                                <>
                                <div className="mobileButton" onClick={contactUs}>
                                    <p>Contact us</p>
                                    <TbMailFilled size={22} className="iconLight"/>
                                </div>
                                <div className="mobileButton" onClick={download}>
                                    <p>Download</p>
                                    <MdDownloadForOffline size={22} className="iconLight"/>
                                </div>
                                </>
                                :
                                page === "contactUs" ?
                                <div className="mobileCard">
                                    <div className="mobileCardHeader">
                                        <TbMailFilled size={22} className="iconDark"/>
                                        <p className="mobileCardTitle">Contact us</p>
                                    </div>
                                    <p>Feel free to contact us for either any marketing propose or technical issue.</p>
                                    <p id="mobileCardMail">contact.mylife@gpdev.me</p>
                                </div>
                                :
                                <div className="mobileCard">
                                    <div className="mobileCardHeader">
                                        <MdDownloadForOffline size={22} className="iconDark"/>
                                        <p className="mobileCardTitle">Download</p>
                                    </div>
                                    <p>You can download MyL!fe app on Google Play Store. We're working to make it available on App Store, soon.</p>
                                    <div className="mobileCardStoreContainer">
                                        <a className="mobileCardStore" href="https://play.google.com/store/apps?hl=it&pli=1" target="_blank">
                                            <img src={require("./assets/playStore.png")} className="storeLogo"/>
                                            <p>Play Store</p>
                                        </a>
                                        <a className="mobileCardStore" href="https://www.apple.com/it/app-store/" target="_blank">
                                            <img src={require("./assets/appStore.png")} className="storeLogo"/>
                                            <p>App Store</p>
                                        </a>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    {
                        page === "home" &&
                        <div id="mobileFooter">
                            <p>MyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe</p>
                            <p>!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe</p>
                            <p>MyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe</p>
                            <p>!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!feMyL!fe</p>
                        </div>
                    }

                </>

            }
            
        </div>

        <div id="infoContainer">

            <div className="infoSection">
                <h1 className="infoTitle">Privacy Policy</h1>
                <p className="infoText">
                    Last updated: August 18, 2025<br/><br/>

                    <b>1. Data We Collect</b><br/>
                    - Information you provide: name, email, birthday date and any content you upload.<br/>
                    - User preferences, such as your preferred language.<br/><br/>

                    <b>2. How We Use Data</b><br/>
                    - To provide and improve the app.<br/>
                    - To communicate updates on your account status (registration, login...).<br/>
                    - To analyze app usage and improve features.<br/><br/>

                    <b>3. Data Sharing</b><br/>
                    We do not sell data to third parties. We may share data with service providers (hosting, analytics) who comply with privacy standards.<br/><br/>

                    <b>4. Security</b><br/>
                    We protect data with appropriate technical and organizational measures.<br/><br/>

                    <b>5. User Rights</b><br/>
                    Creation, modification, and deletion of your account (password required; if forgotten, contact us by email).<br/><br/>

                    <b>6. Minor Users</b><br/>
                    The app is intended for users aged 16 and above. Users under 18 should use the app with parental consent.<br/><br/>

                    <b>7. Changes to Privacy Policy</b><br/>
                    We may update this page at any time. We recommend checking it periodically.
                </p>
            </div>

            <div className="infoSection">
                <h1 className="infoTitle">Terms of Service</h1>
                <p className="infoText">
                    Last updated: August 18, 2025<br/><br/>

                    <b>1. Acceptance of Terms</b><br/>
                    By using the MyL!fe app, you agree to these Terms. If you do not agree, do not use the app.<br/><br/>

                    <b>2. Use of the App</b><br/>
                    You may not use the app for illegal or harmful purposes. The app is provided “as is” without explicit or implied warranties.<br/><br/>

                    <b>3. User-Generated Content</b><br/>
                    You are responsible for any content you upload. Do not upload material that infringes copyrights or the rights of others.<br/><br/>

                    <b>4. Purchases and Subscriptions</b><br/>
                    Any payments are handled through Google Play or the App Store. Prices are specified in the app. We are not responsible for technical payment issues.<br/><br/>

                    <b>5. Limitation of Liability</b><br/>
                    We are not responsible for direct or indirect damages resulting from app use. The app is intended for personal purposes.<br/><br/>

                    <b>6. App Changes</b><br/>
                    We may update, modify, or suspend the app at any time.<br/><br/>

                    <b>7. Governing Law</b><br/>
                    These terms are governed by Italian law. Any disputes will be handled in Italian courts.<br/><br/>

                    <b>8. Contact</b><br/>
                    For questions or complaints, write to our email address.<br/><br/>

                    <b>9. Account Termination</b><br/>
                    We reserve the right to suspend or delete any account at our sole discretion, at any time and for any reason, without prior notice or liability.<br/><br/>

                    <b>10. Errors and Availability</b><br/>
                    We do not guarantee that the app will always function without interruptions, errors, or bugs. While we strive to maintain the service, technical issues may occur and we are not liable for any damages resulting from such issues.<br/><br/>
                </p>
            </div>

            <div id="socialsContainer">

                <a className="socialLink" href="https://www.instagram.com/officialmylifeapp/">
                    <img src={require("./assets/instagram.png")} className="social"/>
                </a>

                <a className="socialLink" href="https://www.tiktok.com/@officialmylifeapp">
                    <img src={require("./assets/tiktok.png")} className="social"/>
                </a>

            </div>

        </div>

        </>

    )

}